import React from 'react'
import { colors } from '../../styles/utils'

const ListTableMultiColumn = ({ columnConfig, data, style, ...props }) => {
  return (
    <div
      className='ListTable'
      style={{ ...ListTableStyles.container, ...style }}
      {...props}
    >
      <div className='tableHeading' style={ListTableStyles.heading}>
        {columnConfig &&
          columnConfig.map((col, i) => (
            <span key={i} style={col.style || { textAlign: 'left' }}>
              {col.name}
            </span>
          ))}
      </div>
      <ul style={ListTableStyles.ul}>
        {data &&
          data.map((row, i) => (
            <li key={i} style={{ ...ListTableStyles.li }}>
              {columnConfig &&
                columnConfig.map((col, ii) => (
                  <span key={ii} style={col.style || { textAlign: 'left' }}>
                    {row[col.data_key]}
                  </span>
                ))}
            </li>
          ))}
      </ul>
    </div>
  )
}


const ListTableStyles = {
  container: {
    width: '100%',
    position: 'relative',
    fontSize: '0.875rem'
  },
  heading: {
    display: 'flex',
    color: colors.mediumGray,
    justifyContent: 'space-between',
    width: '100%',
    borderBottom: `1px solid ${colors.mediumGray}`,
    paddingBottom: 4,
    fontSize: '0.85rem',
    fontWeight: 500
  },
  ul: {
    listStyleType: 'none',
    padding: 0,
    margin: 0
  },
  li: {
    padding: '15px 5px',
    width: '100%',
    display: 'flex',
    fontSize: '1rem',
    color: colors.gray,
    justifyContent: 'space-between',
    borderBottom: `1px solid ${colors.lightGray}`
  }
}

export default ListTableMultiColumn
